import { TipoEmpresaServiciosEnum } from "@api/api";

// Grid Components
import EmpresasServiciosEnergiaGrid from "@/components/empresas-servicios/energia/EmpresasServiciosEnergiaGrid.vue";
import EmpresasServiciosAguaGrid from "@/components/empresas-servicios/agua/EmpresasServiciosAguaGrid.vue";

// GestionTab Components
import EmpresaServiciosEnergiaGestionTab from "@/components/empresas-servicios/energia/EmpresaServiciosEnergiaGestionTab.vue";
import EmpresaServiciosAguaGestionTab from "@/components/empresas-servicios/agua/EmpresaServiciosAguaGestionTab.vue";
import type { Component } from "vue";

const gridComponents = {
  [TipoEmpresaServiciosEnum.Energia]: EmpresasServiciosEnergiaGrid,
  [TipoEmpresaServiciosEnum.Agua]: EmpresasServiciosAguaGrid,
} as const;

const gestionTabComponents = {
  [TipoEmpresaServiciosEnum.Energia]: EmpresaServiciosEnergiaGestionTab,
  [TipoEmpresaServiciosEnum.Agua]: EmpresaServiciosAguaGestionTab,
} as const;

const getGridComponent = (tipoServicio: string) : Component => {
  const tipo = tipoServicio?.toUpperCase() as TipoEmpresaServiciosEnum;
  return gridComponents[tipo] || gridComponents[TipoEmpresaServiciosEnum.Energia];
}

const getGestionTabComponent = (tipoServicio: string) : Component => {
  const tipo = tipoServicio?.toUpperCase() as TipoEmpresaServiciosEnum;
  return gestionTabComponents[tipo] || gestionTabComponents[TipoEmpresaServiciosEnum.Energia];
}

export { getGridComponent, getGestionTabComponent };
